import { render, staticRenderFns } from "./rating-2.vue?vue&type=template&id=03b8fc14&"
import script from "./rating-2.vue?vue&type=script&lang=js&"
export * from "./rating-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports